import { render, staticRenderFns } from "./SellersCreate.vue?vue&type=template&id=4a994784"
import script from "./SellersCreate.vue?vue&type=script&lang=js"
export * from "./SellersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports